import { Carousel, notification } from "antd";
import React from "react";
import SlickButtonFix from "./shared/SlickButtonFix";
import { mdiFountainPenTip, mdiMenuLeft, mdiMenuRight } from "@mdi/js";
import Icon from "@mdi/react";
import RibbonSection from "./shared/RibbonSection";
import TestimonialsApi from "../../api-services/testimonials-api.service";
import { Testimonial } from "../../interfaces/testimonial.interface";
import createDOMPurify from 'dompurify'
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const DOMPurify = createDOMPurify(window)

export default class Testimonials extends React.Component {
  api = new TestimonialsApi;

  state = {
    reviews: []
  }

  componentDidMount() {
    this.api.getTestimonials()
      .then(testimonialsData => {
        this.setState({reviews: testimonialsData})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading testimonials.'});
      });
  }

  render(){
    return (
      <RibbonSection title="Testimonial">
        <div id="testimonials">
          <Carousel autoplay arrows dots={false} draggable slidesToScroll= {1} slidesToShow={this.state.reviews.length > 3 ? 3 : this.state.reviews.length}
            prevArrow={
              <SlickButtonFix>
                <Icon path={mdiMenuLeft} size={4} />
              </SlickButtonFix>
            }
            nextArrow={
              <SlickButtonFix>
                <Icon path={mdiMenuRight} size={4} />
              </SlickButtonFix>
            }>
            {
              this.state.reviews.map((review:Testimonial)=>{
                return (
                  <div key={review.id} className="testimonial">
                    <img src="/iceholidays-assets/images/5star.png" className="stars-icon"/>
                    <div className="tour">
                      <img src="/iceholidays-assets/images/logomark.png" className="st-logo"/>
                      <div>
                        <span> {review.title} </span>
                      </div>
                    </div>
                    <div className="comment">
                      <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{review.comment}</Markdown>
                    </div>
                    <div className="author">
                      <Icon path={mdiFountainPenTip} size={1} className="author-icon" />
                      <span>{review.author}</span>
                    </div>
                  </div>
                )
              })
            }
          </Carousel>
        </div>
      </RibbonSection>
    )
  }
}

const reviews = [
  {
    key: 1,
    itinerarySummaryTitle: "8D6N 8D6N PREMIUM KOREA:",
    itinerarySummaryDesc: "SPLENDOR OF WINTER",
    comment: "Thanks to our exceptional guide ANDY & MEILAN. 👍👍👍The Korea tour was fantastic,Their deep knowledge and engaging style made the experience truly memorable. Highly recommend for anyone wanting an insightful and enjoyable tour of Korea!🇰🇷 …",
    customerName: "Evon Ooi"
  },
  {
    key: 2,
    itinerarySummaryTitle: "review 2",
    comment: "Thanks to our exceptional guide ANDY & MEILAN. 👍👍👍The Korea tour was fantastic,Their deep knowledge and engaging style made the experience truly memorable. Highly recommend for anyone wanting an insightful and enjoyable tour of Korea!🇰🇷 …",
    customerName: "Evon Ooi"
  },
  {
    key: 3,
    itinerarySummaryTitle: "review 3",
    comment: "Thanks to our exceptional guide ANDY & MEILAN. 👍👍👍The Korea tour was fantastic,Their deep knowledge and engaging style made the experience truly memorable. Highly recommend for anyone wanting an insightful and enjoyable tour of Korea!🇰🇷 …",
    customerName: "Evon Ooi"
  },
]

